import React, { Component } from 'react';
import _ from 'lodash';

import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import '../pages/documents/stylesheets/PositionsUserTable.css';

import { MergeAttributes } from './FlatData';

class MultiplePositionsUserTable extends Component {
  constructor(props){
    super(props)

    this.state = {
      selectedInformeeIds: this.props.selectedIds,
      selectedInformees: this.props.selectedIds,
      currentPage: 1,
    }

    this.onSelectInformee = this.onSelectInformee.bind(this);
    this.handleSelectAll = this.handleSelectAll.bind(this);
  }

  onSelectInformee(row, isSelected, e) {
    let { selectedInformeeIds, selectedInformees } = this.state;
    const isIncluded = _.includes(selectedInformees, row.id);

    if (isIncluded){
      selectedInformees = _.pull(selectedInformees, row.id)
      selectedInformeeIds = _.pull(selectedInformeeIds, row.id)
    }else{
      selectedInformees = _.union(selectedInformees, [row.id])
      selectedInformeeIds = _.union(selectedInformeeIds, [row.id])
    }

    this.setState({ 
      selectedInformees: selectedInformees,
      selectedInformeeIds: selectedInformeeIds,
    });

    this.props.onSelectInformee(selectedInformeeIds);
  }

  onPageChange(page, sizePerPage) {
    // console.log(this.refs.fwdputable);

    setTimeout(() => {
      let { data, selectedRowKeys } = this.refs.fwdputable.state;
      let { selectedInformeeIds } = this.state
      let selectedInformees = []

      selectedInformeeIds = _.union(selectedInformeeIds, selectedRowKeys)

      const showingInformeeIds = data.map(row => row.id)
      selectedInformees = _.intersection(showingInformeeIds, selectedInformeeIds)

      this.setState({ 
        selectedInformeeIds: selectedInformeeIds,
        selectedInformees: selectedInformees,
        currentPage: page
      });

      this.props.onSelectInformee(selectedInformeeIds);
    }, 10);
  }

  onSearchChange(searchText, colInfos, multiColumnSearch) {
    // console.log(this.refs.fwdputable);

    setTimeout(() => {
      let { data, selectedRowKeys } = this.refs.fwdputable.state;
      let { selectedInformeeIds } = this.state
      let selectedInformees = []

      selectedInformeeIds = _.union(selectedInformeeIds, selectedRowKeys)

      const showingInformeeIds = data.map(row => row.id)
      selectedInformees = _.intersection(showingInformeeIds, selectedInformeeIds)

      this.setState({ 
        selectedInformeeIds: selectedInformeeIds,
        selectedInformees: selectedInformees,
      });

      this.props.onSelectInformee(selectedInformeeIds);
    }, 10);
  }

  handleSelectAll(isSelected, rows) {
    let { selectedInformeeIds, selectedInformees } = this.state;
    const row_ids = rows.map(row => row.id)
   
    if (isSelected) {
      selectedInformees = _.union(selectedInformees, row_ids)
      selectedInformeeIds = _.union(selectedInformeeIds, selectedInformees)
    } else {
      selectedInformees = []
      selectedInformeeIds = _.pullAll(selectedInformeeIds, row_ids)
    }

    this.setState({
      selectedInformeeIds: selectedInformeeIds,
      selectedInformees: selectedInformees,
    });

    this.props.onSelectInformee(selectedInformeeIds);

    return selectedInformees;
  }

  render(){
    const data = MergeAttributes(this.props.positions_users);

    const selectRowProp = {
      mode: 'checkbox',
      clickToSelect: true,
      onSelect: this.onSelectInformee,
      selected: this.state.selectedInformees,
      onSelectAll: this.handleSelectAll
    };

    const options = {
      sizePerPageList: [],
      onPageChange: this.onPageChange.bind(this),
      onSearchChange: this.onSearchChange.bind(this),
      page: this.state.currentPage,
      selected: this.state.selectedInformees,
    };

    return(
      <div className="row">
        <div className="col-12 rui-positions-user-tb">
          <BootstrapTable 
            ref='fwdputable'
            data={data}
            search={ true }
            multiColumnSearch={ true }
            selectRow={ selectRowProp }
            options={ options }
            striped
            hover
            condensed
            pagination
            version='4'
            tableContainerClass={'table-sm'}>
              <TableHeaderColumn isKey dataField='id' hidden></TableHeaderColumn>
              <TableHeaderColumn dataField='user_name' dataSort={ true }>ชื่อ-นามสกุล</TableHeaderColumn>
              <TableHeaderColumn dataField='position_name' dataSort={ true }>ตำแหน่ง</TableHeaderColumn>
              <TableHeaderColumn dataField='department_name' dataSort={ true }>แผนก</TableHeaderColumn>
          </BootstrapTable>
        </div>
      </div>
    )
  }
}

export default MultiplePositionsUserTable;



// WEBPACK FOOTER //
// ./src/components/MultiplePositionsUserTable.js